/**
 * Serialize a thrown value for logging. `JSON.stringify(error)` yields "{}" for
 * Error instances (message/stack are non-enumerable), which hid the real cause of
 * BUG-1018355. This captures the message/stack, falls back to own-property dump for
 * plain objects (e.g. Cordova callback errors), and String() for primitives.
 */
export function describeError(e: any): string {
	if (e instanceof Error) {
		return `${e.name}: ${e.message} | ${e.stack}`;
	}
	if (e && typeof e === 'object') {
		const own: any = {};
		for (const k of Object.getOwnPropertyNames(e)) { own[k] = e[k]; }
		return `${JSON.stringify(own)} | ${String(e)}`;
	}
	return String(e);
}

export const CaptureUtils = {

    ippObject: {
        isDefaultSettings: true,
        processorOptions: "",
        defaultProcessString: "",
        commonProcessString: "",
        cskewString: "",
    },

    EMPTY_STR: "",

    //Form ipp string based on options.
	getIPPString(object) {
		var options = object.processorOptions;
		var ippString = this.EMPTY_STR;

		if (!object.isDefaultSettings) {
			var despeckleString = this.EMPTY_STR;

			if (
				options.despeckle != this.EMPTY_STR &&
				options.despeckle != null &&
				options.despeckle > 0 &&
				options.despeckle <= 9
			) {
				despeckleString = "_DoDespeck_" + options.despeckle;
			}

			ippString =
            this.EMPTY_STR +
				options.mode +
				options.autoCrop +
				options.autoRotate +
				options.backgroundSmoothing +
				options.scaleDpi +
				despeckleString +
				options.sharpen;

			if (options.deskew) {
				ippString = ippString + options.deskewBy;
			}

			if (options.cSkewSettings && object.cskewString != null) {
				ippString += object.cskewString;
			}
		} else {
			ippString = object.defaultProcessString;
		}
		if (object.commonProcessString != null) {
			ippString += object.commonProcessString;
		}
		return ippString;
	},

    deleteImage(img) {
		if (img && img !== "undefined") {
			// Remove the previous taken image from the image array
			img.deleteImage(
				function (result) {
					console.log("Delete image success callback " + JSON.stringify(result));
				},
				function (deleteImageError) {
					alert("Delete image error callback " + JSON.stringify(deleteImageError));

					console.log("Delete image error callback " + JSON.stringify(deleteImageError));
				}
			);
		}
		img = null;
	},

    //Show alert after specified timeout
	showAlertWithTimeout(msg, timeout) {
		setTimeout(function () {
			alert("Error in server response: " + JSON.stringify(msg));
		}, timeout);
	},

    // Form the response same as RTTI
	mergeExtractedResult(callback, results) {
		const extractedResults = JSON.parse(results);
		const dict = extractedResults.d;
		const docFields = dict.ReturnedDocumentFields;
		const arrFields = docFields[0].ReturnedDocumentFields;
		const dictResponse = {
			documentId: dict.ParentId,
			fields: [],
		};
		let data = [];
		for (let i = 0; i < arrFields.length; i++) {
			const dictFields = arrFields[i];
			const dictObj = {
				id: dictFields.Id === null ? "" : dictFields.Id,
				text: dictFields.Value === null ? "" : dictFields.Value,
				name: dictFields.Name === null ? "" : dictFields.Name,
				confidence: dictFields.Confidence === null ? "" : dictFields.Confidence,
				errorDescription: dictFields.ErrorDescription === null ? "" : dictFields.ErrorDescription,
				valid: dictFields.Valid === null ? "" : dictFields.Valid,
			};
			data.push(dictObj);
		}
		dictResponse.fields = data;
		callback(dictResponse);
	},

    // Return error message based on error code
    getErrorMessageFromCode(errorCode) {
        var errorMessage = "The server may be offline or does not exist";
        if (errorCode == 500) {
            errorMessage = "Could not read the document.";
        } else if (errorCode == -1001) {
            errorMessage = "The Request timed out.";
        } else if (errorCode == -1009) {
            errorMessage = "Extraction cannot be performed because the app cannot connect to the network.";
        } else if (errorCode == -1003) {
            errorMessage = "A server with the specified hostname could not be found.";
        }
        return errorMessage;
    },

    hasNotch() {
		if (CSS.supports("padding-bottom: env(safe-area-inset-bottom)")) {
			var div = document.createElement("div");
			div.style.paddingBottom = "env(safe-area-inset-bottom)";
			document.body.appendChild(div);
			var calculatedPadding = parseInt(window.getComputedStyle(div).paddingBottom, 10);
			document.body.removeChild(div);
			if (calculatedPadding > 0) {
				return true;
			}
		}
		return false;
	},

	checkPermissionEnabled(successcallback, errorcallback, permission) {
		// cordova.plugins.diagnostic.getPermissionAuthorizationStatus(
		// 	function (status) {
		// 		switch (status) {
		// 			case cordova.plugins.diagnostic.permissionStatus.GRANTED:
		// 				console.log("Permission granted to use the gallery");
		// 				successcallback();
		// 				break;
		// 			case cordova.plugins.diagnostic.permissionStatus.DENIED_ONCE:
		// 			case cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
		// 			case cordova.plugins.diagnostic.permissionStatus.NOT_REQUESTED:
		// 				alert("This app does not have access to your photos");
		// 				console.log("Permission denied to use the Gallery");
		// 				break;
		// 			default:
		// 				break;
		// 		}
		// 	},
		// 	function (error) {
		// 		console.error("The following error occurred: " + error);
		// 		errorcallback(error);
		// 	},
		// 	permission
		// );
	}
}

	// export const showLoadingIndicator = () => {
	// 	$("body").append('<div class="modalWindow"/>');
	// 	$.mobile.loading("show", {
	// 		text: "Please Wait",
	// 		textVisible: true,
	// 		theme: "b",
	// 		html: "",
	// 	});
	// }

	// function hideLoadingIndicator() {
	// 	$(".modalWindow").remove();
	// 	$.mobile.loading("hide");
	// }











